<script setup lang="ts">
interface Props {
  cols?: number
  minCols?: number
  gap?: 'none' | 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

const props = withDefaults(defineProps<Props>(), {
  cols: 1,
  minCols: 2,
  gap: 'sm',
})

const _class = ({
  cols = props.cols,
  minCols = props.minCols,
  gap = props.gap,
}: Partial<typeof props> = props) => ({
  'grid items-stretch': true,
  [`grid-cols-${minCols}`]: minCols > 0,
  'md:grid-cols-2': cols % 2 === 0,
  'md:grid-cols-3': cols % 3 === 0,
  'md:grid-cols-4': cols % 4 === 0,
  'lg:grid-cols-6': cols >= 6,
  'gap-0': gap === 'none',
  'gap-1': gap === 'xs',
  'gap-2': gap === 'sm',
  'gap-4': gap === 'md',
  'gap-5': gap === 'lg',
  'gap-6': gap === 'xl',
})
</script>

<template>
  <div
    class="w-full"
    :class="_class()"
  >
    <slot :class-getter="_class" />
  </div>
</template>
